import { render, staticRenderFns } from "./ProductLocalizationEditorCard.vue?vue&type=template&id=1d296eba&scoped=true&"
import script from "./ProductLocalizationEditorCard.vue?vue&type=script&lang=js&"
export * from "./ProductLocalizationEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d296eba",
  null
  
)

export default component.exports